<form #formStep="ngForm" novalidate autocomplete="off">
    <div class="bg-blue-gradient">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap align-items-center py-4 pb-md-5">
                        <div class="col-auto">
                            <label class="number">{{ step }}</label>
                        </div>
                        <div class="col-auto flex-shrink-1">
                            <p class="text-blue mb-0">
                                {{ question.description }}
                            </p>
                        </div>
                    </div>

                    <div class="row justify-content-center justify-content-md-end">
                        <div class="col-11 options">
                            <ng-template ngFor let-group [ngForOf]="groups" let-i="index">
                                <div class="row align-items-center mb-3">
                                    <div class="col-12 col-lg-9">
                                        <p class="mb-0">
                                            {{ group.description }}
                                        </p>
                                    </div>
                                    <div class="col-12 col-lg-3 pt-3 pt-lg-0">
                                        <thr-radio-group
                                            [name]="'option' + i"
                                            [(ngModel)]="selected[i]"
                                            (ngModelChange)="onSelectedChange(i)"
                                            [required]="true"
                                            *ngIf="!isDisabled(i)"
                                        >
                                            <ng-template ngFor let-option [ngForOf]="group.options">
                                                <thr-radio-button [size]="56" [value]="option">
                                                    <strong>{{ option.description }}</strong>
                                                </thr-radio-button>
                                            </ng-template>
                                        </thr-radio-group>
                                        <thr-radio-group
                                            [name]="'option' + i"
                                            [(ngModel)]="selected[i]"
                                            [required]="false"
                                            *ngIf="isDisabled(i)"
                                        >
                                            <ng-template ngFor let-option [ngForOf]="group.options">
                                                <thr-radio-button [size]="56" [value]="option" [disabled]="true">
                                                    <strong>{{ option.description }}</strong>
                                                </thr-radio-button>
                                            </ng-template>
                                        </thr-radio-group>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="container">
    <div class="row align-items-center mt-3 mt-md-5 mb-4">
        <div class="col-12 col-sm-2 col-md-4">
            <p class="mb-0">
                {{ 'test.question' | translate }}
                <strong>{{ stepNumber }}</strong> {{ 'test.of' | translate }}
                {{ totalSteps }}
            </p>
        </div>
        <div class="col-12 col-sm-5 col-md-4 mt-3 mt-sm-0">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onBack()">
                {{ 'test.back' | translate }}
            </button>
        </div>
        <div class="col-12 col-sm-5 col-md-4 mt-3 mt-sm-0">
            <button
                type="button"
                class="full-width mat-elevation-z0"
                mat-raised-button
                color="blue"
                [disabled]="!formStep.valid"
                (click)="onClick()"
            >
                <ng-container *ngIf="!isLastQuestion">{{ 'test.next' | translate }}</ng-container>
                <ng-container *ngIf="isLastQuestion">{{ 'test.finish' | translate }}</ng-container>
            </button>
        </div>
    </div>
</div>
